import { render, staticRenderFns } from "./index-pc.vue?vue&type=template&id=5777b7d8&scoped=true&"
import script from "./index-pc.vue?vue&type=script&lang=js&"
export * from "./index-pc.vue?vue&type=script&lang=js&"
import style0 from "./index-pc.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index-pc.vue?vue&type=style&index=1&id=5777b7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777b7d8",
  null
  
)

export default component.exports